
export const tokensDark = {
  grey: {
    0: "#ffffff", // manually adjusted
    10: "#f6f6f6", // manually adjusted
    50: "#f0f0f0", // manually adjusted
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
    1000: "#000000", // manually adjusted
  },
  blue: {
    100: "#cce4f0",
    200: "#99c9e2",
    300: "#66add3",
    400: "#3392c5",
    500: "#0077b6",
    600: "#005f92",
    700: "#00476d",
    800: "#003049",
    900: "#001824"
  },
  primary: {
    // blue
    //500 color sidebar
    100: "#ccd5de",
    200: "#99aabd",
    300: "#669d78",
    400: "#337c34",
    500: "#002b5b",
    600: "#002249",
    700: "#006250",
    800: "#012821",
    900: "#000912"
  },
  secondary: {
    // yellow
    50: "#f0f0f0", // manually adjusted
    100: "#d2e8e2",
    200: "#a5d0c6",
    300: "#08ab9c",
    400: "#4ca18d",
    500: "#1f8a70",
    600: "#006250",
    700: "#135343",
    800: "#0c372d",
    900: "#061c16"
  },
  tertiary: {
    100: "#0f2922",
    200: "#1e5245",
    300: "#2e7c67",
    400: "#3da58a",
    500: "#4cceac",
    600: "#08AB9C",
    700: "#94e2cd",
    800: "#b7ebde",
    900: "#dbf5ee"
  }
};

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {};
  Object.entries(tokensDark).forEach(([key, val]) => {
    const keys = Object.keys(val);
    const values = Object.values(val);
    const length = keys.length;
    const reversedObj = {};
    for (let i = 0; i < length; i++) {
      reversedObj[keys[i]] = values[length - i - 1];
    }
    reversedTokens[key] = reversedObj;
  });
  return reversedTokens;
}
export const tokensLight = reverseTokens(tokensDark);

// mui theme settings
export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
          // palette values for dark mode
          primary: {
            ...tokensDark.primary,
            main: tokensDark.primary[700],
            light: tokensDark.primary[100],
          },
          secondary: {
            ...tokensDark.secondary,
            main: tokensDark.secondary[300],
          },
          tertiary: {
            ...tokensDark.tertiary,
            main: tokensDark.tertiary[500]
          },
          neutral: {
            ...tokensDark.grey,
            main: tokensDark.grey[500],
          },
          background: {
            default: tokensDark.primary[800],
            alt: tokensDark.primary[600],
          },
        }
        : {
          // palette values for light mode
          primary: {
            ...tokensLight.primary,
            main: tokensDark.grey[50],
            light: tokensDark.grey[100],
          },
          secondary: {
            ...tokensLight.secondary,
            main: tokensDark.secondary[600],
            light: tokensDark.secondary[700],
          },
          tertiary: {
            ...tokensDark.tertiary,
            main: tokensDark.tertiary[500]
          },
          neutral: {
            ...tokensLight.grey,
            main: tokensDark.grey[500],
          },
          background: {
            default: tokensDark.grey[50], //color de fondo
            alt: "#353a40", //color de fondo del menu
          },
        }),
    },
    typography: {
      // fontFamily: ["Inter", "sans-serif"].join(","),
      fontFamily: "Montserrat",
      fontSize: 12,
      h1: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 40,
      },
      h2: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 32,
      },
      h3: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 24,
      },
      h4: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 20,
      },
      h5: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 16,
      },
      h6: {
        // fontFamily: ["Inter", "sans-serif"].join(","),
        fontFamily: "Montserrat",
        fontSize: 14,
      },
    },
    components: {
      MuiAlert: {
        styleOverrides: {
          root: {
            backgroundColor: '#006250', // Personaliza el color de fondo del Alert
            color: '#F0F0F0', // Personaliza el color del texto del Alert
          },
        },
      },
    }
  };
};